import PropTypes from 'prop-types';
import React from 'react';
import SurveyPage from '~app/components/Survey/SurveyPage';
import './survey-pages.scss';

const SurveyPages = props => {
  const { pages, survey } = props;
  const totalPages = pages.length;
  const pagesElement = pages.map((page, idx) => (
    <SurveyPage page={page} survey={survey} pageIndex={idx} totalPages={totalPages} key={page.id} />
  ));

  return (
    <div className="sm-survey-pages--container" data-testid="SurveyPages__Container">
      <div>{pagesElement}</div>
    </div>
  );
};

SurveyPages.propTypes = {
  pages: PropTypes.arrayOf(PropTypes.shape({})),
  survey: PropTypes.shape({}),
};

SurveyPages.defaultProps = {
  pages: [],
  survey: null,
};

export default SurveyPages;
